import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useLayoutEffect, useMemo, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { useRouter } from 'next/router';
import { useSession } from '@techstyle/redux-core';
import adminReducer, { initialState } from '../adminReducer'; // Helper for calling `useLayoutEffect` that shuts up the annoying server
// warning.

var useServerSafeLayoutEffect = process.browser ? useLayoutEffect : () => {};
export var AdminContext = /*#__PURE__*/React.createContext({
  // Supply a default context value where `enabled` is false, so that other
  // extensions can safely render `<AdminGuard>` even if the app doesn't have
  // the `adminExtension` itself enabled. Otherwise, the context value would be
  // undefined and thus accessing `enabled` would throw an error.
  enabled: false
});
export default function AdminProvider(_ref) {
  var children = _ref.children;

  var _useSession = useSession(),
      session = _useSession.session;

  var isAdmin = session.isAdmin;
  var router = useRouter(); // Allow forcing admin tools open in dev mode by adding `?admin=1` or `?admin=true`.

  var _useState = useState(() => config.get('public.admin.allowOverride') && /^(true|1)$/.test(router.query.admin)),
      _useState2 = _slicedToArray(_useState, 2),
      forceAdmin = _useState2[0],
      setForceAdmin = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activePanelNode = _useState4[0],
      setActivePanelNode = _useState4[1];

  var _useReducer = useReducer(adminReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var value = useMemo(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispatch,
      enabled: isAdmin || forceAdmin,
      isAdmin,
      forceAdmin,
      setForceAdmin,
      activePanelNode,
      setActivePanelNode
    });
  }, [state, isAdmin, forceAdmin, activePanelNode]);
  useServerSafeLayoutEffect(() => {
    state.effects.forEach(effect => effect());
  }, [state.effects]);
  return /*#__PURE__*/React.createElement(AdminContext.Provider, {
    value: value
  }, children);
}
AdminProvider.Context = AdminContext;
AdminProvider.propTypes = {
  children: PropTypes.node
};